import '../App.css'
import { Spinner } from '../Utils/Spinner'
import { Footer } from '../MainPage/Footer'


export const NewsInfo = ({ data, loading, error }) => {

    const dataCopy = { ...data }

    if (loading) return <Spinner />
    if (error) return "something bad"

    dataCopy.allInfos.sort((a, b) => b.fecha.localeCompare(a.fecha));

    return (
        <>
            {
                dataCopy.allInfos.map(({ titulo, fecha, descripcion, id }) => {
                    return <div className='data-container' key={id}>

                        <div>
                            <h3>{titulo}</h3>
                        </div>

                        <div className='container-text-p'>
                            <span>
                                {fecha.split('-').reverse().join('/')}
                            </span>
                        </div>

                        <div className='container-text-p'>
                            <p>
                                {descripcion}
                            </p>
                        </div>
                    </div>
                })
            }
            {!loading && <Footer id={'footer-main'} />}
        </>
    )
}
// .sort((a,b)=>console.log(a))